import qs from "qs"
import { CSSProperties } from "react"

export default class AppRoute<P = {}, Q = {}> {
    route: string
    navbar?: boolean
    authRequired?: boolean
    minWidth?: CSSProperties["minWidth"]

    constructor({
        route,
        navbar,
        authRequired,
        minWidth,
    }: {
        route: string
        exact?: boolean
        navbar?: boolean
        authRequired?: boolean
        minWidth?: CSSProperties["minWidth"]
    }) {
        this.route = route
        this.navbar = navbar
        this.authRequired = authRequired
        this.minWidth = minWidth
    }

    public getPath(params?: P, query?: Q): string {
        let path = this.route
        if (params) {
            const keys = Object.keys(params)
            for (const key of keys) {
                const regExp = new RegExp(`:${key}`, "g")
                path = path.replace(regExp, params[key])
            }
        }
        if (query && Object.keys(query).length > 0) {
            path += `?${qs.stringify(query, { arrayFormat: 'repeat' })}`
        }
        return path
    }
}
